import { filters } from '@/filters/Filters';
import {
    IValueSegment, IEnumSegment, ISkillSegment, IBlowSegment, IItemSegment, IStateVfxSegment, IMonsterSegment,
    IActionSegment, IDurationSegment, IListSegment, ITableSegment, IChildSegment, Segment,
} from './types';

export const seg = {
    /** Verbatim formatted value */
    val(text: string | number, span?: [number, number]): IValueSegment {
        const result: IValueSegment = { kind: 'value', text: String(text) };
        if (span) { result.span = span; }
        return result;
    },
    /** Thousands-separated number */
    num(n: number, span?: [number, number]): IValueSegment {
        const result: IValueSegment = { kind: 'value', text: filters.thousands(n) };
        if (span) { result.span = span; }
        return result;
    },
    /** Identifier-style number — no grouping separators (table rows, group ids, handles) */
    id(n: number, span?: [number, number]): IValueSegment {
        const result: IValueSegment = { kind: 'value', text: String(n) };
        if (span) { result.span = span; }
        return result;
    },
    /** Ratio → "50%" (0.5 → 50%) */
    pct(ratio: number, maxDecimals: number = 2, span?: [number, number]): IValueSegment {
        const result: IValueSegment = { kind: 'value', text: filters.percent(ratio, maxDecimals) + '%' };
        if (span) { result.span = span; }
        return result;
    },
    /** Milliseconds → "2.50s" */
    secs(ms: number, span?: [number, number]): IValueSegment {
        const result: IValueSegment = { kind: 'value', text: filters.milliseconds(ms) + 's' };
        if (span) { result.span = span; }
        return result;
    },
    /** Enum with mandatory integer display; label falls back when out of table */
    en(
        value: number, labels: string[], fallbackLabel: string = 'unknown', span?: [number, number],
    ): IEnumSegment {
        const label = value >= 0 && value < labels.length && value === Math.floor(value)
            ? labels[value] : fallbackLabel;
        const result: IEnumSegment = { kind: 'enum', label, value };
        if (span) { result.span = span; }
        return result;
    },
    skill(id: number, span?: [number, number]): ISkillSegment {
        const result: ISkillSegment = { kind: 'skill', id };
        if (span) { result.span = span; }
        return result;
    },
    blow(id: number, span?: [number, number]): IBlowSegment {
        const result: IBlowSegment = { kind: 'blow', id };
        if (span) { result.span = span; }
        return result;
    },
    item(id: number, span?: [number, number]): IItemSegment {
        const result: IItemSegment = { kind: 'item', id };
        if (span) { result.span = span; }
        return result;
    },
    stateVfx(id: number, span?: [number, number]): IStateVfxSegment {
        const result: IStateVfxSegment = { kind: 'stateVfx', id };
        if (span) { result.span = span; }
        return result;
    },
    monster(id: number, span?: [number, number]): IMonsterSegment {
        const result: IMonsterSegment = { kind: 'monster', id };
        if (span) { result.span = span; }
        return result;
    },
    action(name: string, span?: [number, number]): IActionSegment {
        const result: IActionSegment = { kind: 'action', name };
        if (span) { result.span = span; }
        return result;
    },
    dur(ms: number): IDurationSegment { return { kind: 'duration', ms }; },
    list(items: Segment[][]): IListSegment { return { kind: 'list', items }; },
    table(rows: Segment[][][]): ITableSegment { return { kind: 'table', rows }; },
    child(blowId: number, params: string, durationMs?: number): IChildSegment {
        return { kind: 'child', blowId, params, durationMs };
    },
};
